import React from "react";
import { BoxIcon } from "lucide-react";
type BonusThumbProps = {
  icon: BoxIcon;
  tone: string;
  label: string;
};
const tones: Record<string, string> = {
  mint: "bg-mint text-ink",
  sun: "bg-sun text-ink",
  ink: "bg-ink text-cream"
};
export function BonusThumb({
  icon: Icon,
  tone,
  label
}: BonusThumbProps) {
  return <div className={`relative flex h-24 w-20 shrink-0 flex-col items-center justify-center gap-2 rounded-xl shadow-[4px_4px_0_0_rgba(18,40,60,0.12)] ${tones[tone] ?? tones.mint}`} aria-hidden="true" data-id="element-58" data-mp="nmhx7azqs327">
      <span className="absolute inset-y-0 left-0 w-1.5 rounded-l-xl bg-black/10" data-id="element-59" data-mp="xicmgoyh0wdy" />
      <Icon className="h-7 w-7" data-id="element-60" data-mp="11mkg90jsd2j1" />
      <span className="text-xs font-extrabold" data-id="element-61" data-mp="11jeofdjrvmjm">{label}</span>
    </div>;
}